<template>
  <div class="page page-play">
    <div v-if="klines" class="page__inner">
      <play-head :cup-id="+cupId" :game-id="+gameId" :kid="+kid" :today="today" />
      <play-body :klines="klines" :today="today" />
      <play-foot :cup-id="+cupId" :game-id="+gameId" :kid="+kid" :today="today" />
    </div>
    <div v-else class="page__inner"><txt-loading /></div>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import Head from './head/index'
  import Body from './body/index'
  import Foot from './foot/index'
  export default {
    props: ['cupId', 'gameId', 'kid'],
    components: {
      [Head.name]: Head,
      [Body.name]: Body,
      [Foot.name]: Foot
    },
    computed: {
      ...mapGetters(['realityCupId']),
      ...mapGetters('reality', ['getActionBy', 'getKlineAt']),
      ...mapGetters('reality', {
        // cupId: 'curCupId',
        // gameId: 'curGameId',
        // kid: 'curKid',
        klines: 'playKlines',
        actions: 'playActions'
      }),
      yesterday() {
        return this.getKlineAt(-2)
      },
      today() {
        return this.getKlineAt(-1)
      },
      curAction() {
        return this.getActionBy(this.kid)
      }
    },
    watch: {
      // 如果路由有变化，会再次执行该方法
      '$route': 'fetchData'
    },
    methods: {
      ...mapActions('reality', ['loadPlay']),
      fetchData() {
        const {
          cupId,
          gameId,
          kid
        } = this
        // console.log({cupId, gameId})

        this.loadPlay({
          cupId,
          gameId,
          kid
        })
      }
    },
    async created() {
      this.fetchData()
    }
  };

</script>
